import { render, staticRenderFns } from "./analyse-pic.vue?vue&type=template&id=48d7426c&"
import script from "./analyse-pic.vue?vue&type=script&lang=ts&"
export * from "./analyse-pic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports